import service from "@irati-tracking/tracker"

const TRACKING_ROOT = "tour_"

class TourTracking {
  tourStart = (tourName: string, stepCount: number) => {
    const data = {
      tour_name: tourName,
      step_count: stepCount
    }
    service.trackTourEvent(`${TRACKING_ROOT}start`, data)
  }
  tourPrevious = (tourName: string, currentStep: number, stepCount: number) => {
    const data = {
      tour_name: tourName,
      current_step: currentStep,
      step_count: stepCount
    }
    service.trackTourEvent(`${TRACKING_ROOT}previous`, data)
  }
  tourNext = (tourName: string, currentStep: number, stepCount: number) => {
    const data = {
      tour_name: tourName,
      current_step: currentStep,
      step_count: stepCount
    }
    service.trackTourEvent(`${TRACKING_ROOT}next`, data)
  }
  tourComplete = (tourName: string, stepCount: number) => {
    const data = {
      tour_name: tourName,
      step_count: stepCount
    }
    service.trackTourEvent(`${TRACKING_ROOT}complete`, data)
  }
  tourClose = (tourName: string, currentStep: number, stepCount: number) => {
    const data = {
      tour_name: tourName,
      current_step: currentStep,
      step_count: stepCount
    }
    service.trackTourEvent(`${TRACKING_ROOT}close`, data)
  }
}

const tourTracking = new TourTracking()

export default tourTracking
